import {
  CheckCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'next-export-i18n';
import React from 'react';

import { getCleanLink } from '@/utils/helper';

import ButtonLink from '../buttons/btn-link';
import SimpleCard from '../cards/Card';

type MoreProps = {
  title: string;
  items: string[];
  link: string;
  linkLabel: string;
};

const More = ({ title, items, link, linkLabel }: MoreProps) => {
  const { t } = useTranslation();
  const validLink = getCleanLink(link);
  const isHasValidLink = validLink.length > 0;

  return (
    <SimpleCard>
      <h2 className="text-lg">{title}</h2>
      <hr className="my-4" />
      <ul className={`mt-4 ${isHasValidLink ? 'mb-6' : ''}`}>
        {items.map((item, index) => (
          <li key={index} className="my-3 flex flex-row">
            <CheckCircleIcon className="w-7 text-green-400" />
            <h6 className="ml-3 w-64 text-base">
              {item.replaceAll('/', ' / ')}
            </h6>
          </li>
        ))}

        {items.length <= 0 && (
          <li className="my-3 flex flex-row items-center justify-center">
            <InformationCircleIcon className="w-7 text-gray-400" />
            <h6 className="ml-3 w-64 text-base text-gray-500">
              {t('stage.notAvailable.title')}
            </h6>
          </li>
        )}
      </ul>

      {isHasValidLink && (
        <div className="md:max-w-xs">
          <ButtonLink label={linkLabel} link={validLink} type="outline" />
        </div>
      )}
    </SimpleCard>
  );
};

export default More;
